'use client'
import {
  useQueue
} from "./chunk-7VQNZZGN.mjs";

// src/components/HideOnQueue.tsx
import { Fragment, jsx } from "react/jsx-runtime";
var HideOnQueue = ({ children }) => {
  const { isActive, shouldWaitQueue } = useQueue();
  if (shouldWaitQueue || isActive)
    return null;
  return /* @__PURE__ */ jsx(Fragment, { children });
};

// src/components/QueueView.tsx
import { twMerge } from "tailwind-merge";
import { formatPrice } from "@wbk/utils";
import { useRouter, useTranslation } from "@wbk/config";
import { jsx as jsx2, jsxs } from "react/jsx-runtime";
var QueueView = ({ className = "", style }) => {
  const { locale } = useRouter();
  const { queue, isActive } = useQueue({ autoRefresh: true });
  const { t } = useTranslation("queue_common");
  if (!queue || !isActive)
    return null;
  const percentage = queue.WaitingNumber / queue.TotalInQueue * 100;
  return /* @__PURE__ */ jsxs("div", { className: twMerge("space-y-4", className), style, children: [
    /* @__PURE__ */ jsx2("p", { className: "mb-2 text-xl font-bold", children: t("queue_common:queue_title") }),
    /* @__PURE__ */ jsxs("div", { className: "bg-text/10 rounded-md p-4", children: [
      /* @__PURE__ */ jsx2("h2", { children: formatPrice(Math.max((queue == null ? void 0 : queue.WaitingNumber) || 0, 1), 0) }),
      /* @__PURE__ */ jsx2("p", { className: "text-text-secondary text-sm", children: t("queue_common:queue_position") }),
      /* @__PURE__ */ jsx2("div", { className: "bg-body relative my-2 h-10 w-full rounded-full", children: /* @__PURE__ */ jsx2(
        "div",
        {
          className: "bg-tertiary after:bg-candy-stripes after:ltr:animate-candy-stripes-ltr after:rtl:animate-candy-stripes-rtl absolute top-1/2 h-8 min-w-[80px] -translate-y-1/2 overflow-hidden rounded-full after:absolute after:inset-0 after:z-10 after:bg-[length:75px_75px] ltr:left-1 rtl:right-1",
          style: { width: `${100 - Math.min(percentage, 99)}%` }
        }
      ) }),
      /* @__PURE__ */ jsx2("p", { className: "text-text-secondary text-sm", children: t("queue_common:queue_p1") }),
      (queue == null ? void 0 : queue.MessageAR) || (queue == null ? void 0 : queue.MessageEN) ? /* @__PURE__ */ jsx2("p", { children: (locale == null ? void 0 : locale.startsWith("ar")) ? queue == null ? void 0 : queue.MessageAR : queue == null ? void 0 : queue.MessageEN }) : null
    ] }),
    /* @__PURE__ */ jsx2("p", { className: "text-text-secondary text-sm", children: t("queue_common:queue_p2") })
  ] });
};

export {
  HideOnQueue,
  QueueView
};
//# sourceMappingURL=chunk-MPMBVDCA.mjs.map